import React, { FC } from "react";
import cn from "clsx";

import { Props } from "./types";
import "./style.scss";

const RetailPriceTooltip: FC<Props> = ({ isArrow, isResponsive, message }) => (
  <div
    className={cn("retail-price-tooltip", {
      "tooltip-arrow": isArrow,
      "responsive-view": isResponsive
    })}
  >
    <div className="tooltip-content">
      <div className="header-wrapper">
        <p className="header">{message?.pdpRrpPopupTitle}</p>
      </div>
      <p className="mb-2 main-text">{message?.pdpRrpPopupContent}</p>
    </div>
  </div>
);

export default RetailPriceTooltip;
